export var RecoveryTimeout;
(function (RecoveryTimeout) {
    RecoveryTimeout[RecoveryTimeout["ConnectionState"] = 5000] = "ConnectionState";
    RecoveryTimeout[RecoveryTimeout["IceConnectionState"] = 2000] = "IceConnectionState";
    RecoveryTimeout[RecoveryTimeout["Negotiation"] = 200] = "Negotiation";
})(RecoveryTimeout || (RecoveryTimeout = {}));
//# sourceMappingURL=types.js.map